import React, { useState, useEffect } from 'react';
import './SegmentList.scss';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import CustomListComponent from '../../../components/base/CustomListComponent';
import { NavBarNames } from '../../../config/NavBarNameList';
import { createAction } from '../../../utils';
import DeletePrompt from '../../../components/base/DeletePrompt';
import BaseTabListContainer from '../../base/BaseTabListContainer';
import BaseListContainer from '../../base/BaseListContainer';
import AuthButton from '../../../components/base/AuthButton';
import { PermissionCodes } from '../../../config/PermissionCodes';
import { DELETE_RELATED_SECTIONS } from '../../../config/CustomEnums';

function SegmentList() {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();

  const {
    listFields,
    dataList,
    pageInfo,
    totalPage,
    totalCount,
    currentPage,
    checkedList,
  } = useSelector((state) => ({
    listFields: state.segments.listDisplayFields,
    dataList: state.segments.segmentList,
    pageInfo: state.segments.pageInfo,
    totalPage: state.segments.totalPage,
    totalCount: state.segments.totalCount,
    currentPage: state.segments.currentPage,
    checkedList: state.segments.checkedList,
  }));

  const buttons = [
    <AuthButton
      title={'Create Segment'}
      className="btn-further"
      action={() => {
        // dispatch({ type: 'earningRuleList/clearData' });
        history.push({
          pathname: '/segments/create/',
        });
      }}
      requires={PermissionCodes.addSegment}
    ></AuthButton>,
  ];

  const groupActions = [
    {
      name: 'Delete',
      action: () => {
        // setShowPrompt(true);
        setShowDeletePrompt(true);
      },
      requires: PermissionCodes.deleteSegment,
    },
  ];

  const tabs = [
    // {
    //   name: 'Overview',
    //   content: <div>Overview</div>,
    // },
    {
      name: 'List of Segments',
      content: (
        <BaseTabListContainer
          hideTab={true}
          tabs={[]}
          groupActions={groupActions}
          pageInfo={pageInfo}
          totalCount={totalCount}
          listContent={
            <BaseListContainer
              fields={listFields}
              dataList={dataList}
              totalPage={totalPage}
              model={'segments'}
              permissionGroup={PermissionCodes.segment}
              hasOtherActions={false}
              deleteInfo={{
                data: [],
                title: 'segments',
                relatedName: '',
                onComfirm: {},
                relatedSections: DELETE_RELATED_SECTIONS.SEGMENT,
              }}
            />
          }
        />
      ),
    },
  ];

  const [showDeletePrompt, setShowDeletePrompt] = useState(false);
  const [activeTab, setActiveTab] = useState(tabs[0].name);

  useEffect(() => {
    dispatch({ type: 'segments/clearData' });
  }, [dispatch]);

  useEffect(() => {
    const queryString = require('query-string');
    if (queryString) {
      const searchDict = queryString.parse(location.search);
      const searchKey = queryString.parse(location.search)['search'];
      const stringRank = queryString.parse(location.search)['rank'];
      const stringPage = queryString.parse(location.search)['page'] || 1;
      const rank = stringRank === 'true';
      const page = parseInt(stringPage);

      dispatch(
        createAction('segments/getSegmentsList')({
          page,
          reverse: rank,
          type: '',
          search: searchKey,
          moreSearch: { ...searchDict },
        }),
      );
    }
  }, [dispatch, location]);

  return (
    <>
      <CustomListComponent
        caution={{
          detail:
            'After you create a segment, you can target segment when you create a campaign.',
          title: NavBarNames.segments,
        }}
        defaultActiveKey={activeTab}
        breadcrumb={<CustomBreadcrumb />}
        buttons={buttons}
        tabs={tabs}
        hideTab={false}
        onTabChange={(key) => {
          setActiveTab(key);
          //   let search = '';
          //   if (key !== 'Overview') {
          //     // search = queryString.stringify({
          //     //   [URLFilterKeys.type]: CampaignType.allTypes,
          //     //   [URLFilterKeys.page]: 1,
          //     //   [URLFilterKeys.searchKey]: '',
          //     //   [URLFilterKeys.rank]: true,
          //     // });
          //   }
          //   history.push({ pathname: '/customer', hash: key, search: search });
        }}
      />
      <DeletePrompt
        data={checkedList}
        title={'segments'}
        relatedName={''}
        relatedSections={DELETE_RELATED_SECTIONS.SEGMENT}
        show={showDeletePrompt}
        onClose={() => setShowDeletePrompt(false)}
        onConfirm={() => {
          setShowDeletePrompt(false);
          dispatch(
            createAction('segments/delete')({
              afterAction: () => {
                history.push(location);
              },
            }),
          );
        }}
      />
    </>
  );
}

export default SegmentList;
